// Order the book button add on home page collection section for the The Leatherwork School Book Product start

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product.grid__item').forEach(function (product) {

    var title = product.querySelector('.product__title a');

    if (!title || title.textContent.trim() !== 'The Leatherwork School Book') return;

    var price = product.querySelector('.product__prices');

    if (!price || product.querySelector('.order-the-book-btn')) return;

    var button = document.createElement('a');

    button.href = 'https://store.bookbaby.com/book/leatherwork-school';
    button.textContent = 'Order the Book';
    button.className = 'order-the-book-btn';

    price.insertAdjacentElement('afterend', button);
  });
});

// Order the book button add on home page collection section for the The Leatherwork School Book Product end


// Product Page button text changes order the book start

document.addEventListener('DOMContentLoaded', function () {
  if (
    !document.body.classList.contains('template-product') ||
    window.location.pathname !== '/products/the-leatherwork-school-book'
  ) {
    return;
  }

  var cartButton = document.getElementById('AddToCart');

  if (!cartButton) return;

  var orderButton = document.createElement('a');

  orderButton.href = 'https://store.bookbaby.com/book/leatherwork-school';
  orderButton.textContent = 'Order the Book';
  orderButton.className = cartButton.className;
  orderButton.style.textDecoration = 'none';
  orderButton.style.display = 'flex';
  orderButton.style.alignItems = 'center';
  orderButton.style.justifyContent = 'center';

  cartButton.parentNode.replaceChild(orderButton, cartButton);
});

// Product Page button text changes order the book end
